{
    "ai_modal_title_1": "Améliorez votre texte avec l'IA",
    "ai_modal_title_2": "Générez un nouveau texte à l'aide de l'IA",
    "ai_description": "Utilisez les outils de génération de contenu IA pour améliorer vos textes.",
    "ai_learn_more": "En savoir plus",
    "ai_copy_text": "Copier le texte",
    "ai_describe_your_text": "Décrivez le sujet de votre texte",
    "ai_describe_your_text_example": "For example, a small description for a craft shop...",
    "ai_new_request": "Créer une nouvelle requête",
    "ai_create_text": "Générer du texte",
    "ai_apply_text": "Utiliser le texte",
    "ai_try_one_more": "Essayer à nouveau",
    "ai_correct_errors": "Corriger les erreurs",
    "ai_make_longer": "Étendre",
    "ai_make_shorter": "Raccourcir",
    "ai_simplify": "Simplifier",
    "ai_business_tone": "Formel",
    "ai_ceremonial_tone": "Festif",
    "ai_fun_tone": "Joyeux",
    "ai_friendly_tone": "Amical",
    "ai_change_tone": "Modifier le ton de la voix",
    "ai_improve_text": "Améliorer le texte",
    "ai_words_number": "Nombre de mots :",
    "ai_translate": "Traduire",
    "ai_translate_to_ru": "Traduire en russe",
    "ai_translate_to_en": "Traduire en anglais",
    "ai_add_creativity": "Ajouter de la créativité",
    "ai_text_too_large": "Votre texte est trop long pour utiliser l'IA. Raccourcissez-le ou générez un nouveau texte sur le sujet souhaité à l’aide de l’IA.",
    "ai_translate_to_ua": "Traduire en ukrainien",
    "ai_translate_to_es": "Traduire en espagnol",
    "ai_translate_to_pt": "Traduire en portugais",
    "ai_translate_to_tr": "Traduire en turc",
    "ai_translate_to_fr": "Traduire en français",
    "ai_translate_to_de": "Traduire en allemand",
    "ai_translate_to_it": "Traduire en italien",
    "ai_translate_to_pl": "Traduire en polonais",
    "ai_free_request_error": "Les requêtes gratuites sont terminées",
    "ai_free_request_number": "Numéro de requête : {{ FREE_KEY }} / {{ FREE_KEY_LIMIT }}",
    "ai_request_limit_info": "Vous pouvez utiliser jusqu'à 200 demandes gratuites d'outil IA. Pour faire plus de demandes, activez vos clés API au fournisseur d'IA dans les paramètres de votre compte.",
    "cancel": "Annuler",
    "gpt_error_quota": "Vous avez atteint votre limite de requêtes API. Pour continuer à utiliser les outils d'IA, vérifiez votre limite actuelle ou ajoutez des fonds à votre solde créditeur dans les paramètres du compte OpenAI.",
    "ai_generated_disclaimer": "Vous êtes responsable du texte généré. Vérifiez-le avant de le publier."
}
